import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const getAllUserRoles = async (tenantName: string) => {
    let url = `${NGROK}/api/${tenantName}/custom-user-roles`
    const response = await apiClient({
        method: "GET",
        url
    });
    return response;
}

export const getAdminUsers = async (tenantName: string) => {
    let url = `${NGROK}/api/${tenantName}/getAdminLevelUsers`
    const response = await apiClient({
        method: "GET",
        url
    });
    return response;
}

export const getUsers = async (tenantName: string) => {
    let url = `${NGROK}/api/${tenantName}/getUserLevelUsers`
    const response = await apiClient({
        method: "GET",
        url
    });
    return response;
}

export const createCustomRole = async (tenantName: string, roleName: string, description?: string) => {
    let payload = {
        roleName: roleName,
        roleType: "users",
        parentRoleId: -1,
        description: description?.trim() || undefined
    }
    let url = `${NGROK}/api/${tenantName}/create-custom-role`
    const response = await apiClient({
        method: "POST",
        url,
        data: payload
    });
    return response;
}


export const updateCustomRole = async (tenantName: string, roleName: string, id: number, description?: string) => {
    let payload = {
        id: id,
        roleName: roleName,
        roleType: "users",
        tenantName: tenantName,
        description: description?.trim() || undefined,
        role: {
            roleId: -1
        }
    }
    let url = `${NGROK}/api/${tenantName}/${id}/updateCustomRole`
    const response = await apiClient({
        method: "PUT",
        url,
        data: payload
    });
    return response;
}


export const deleteRole = async (tenantName: string, id: number) => {
    let url = `${NGROK}/api/${tenantName}/${id}/deleteCustomRole`
    const response = await apiClient({
        method: "DELETE",
        url
    });
    return response;
}